import { Node } from '@tiptap/core';

// Define a custom Document node that only accepts draggableBlock nodes as direct children
export const CustomDocument = Node.create({
  name: 'doc', // Must be named 'doc'
  topNode: true, // Required for the document node
  content: 'draggableBlock+', // Content must be one or more draggableBlock nodes
});
